import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ProModuleId =
  | 'governance-pro'
  | 'security-pro'
  | 'risk-pro'
  | 'data-pro'
  | 'compliance-pro'
  | 'change-pro'
  | 'audit-pro'
  | 'ai-ia-pro'
  | 'vendor-pro'
  | 'dashboard-pro'
  | 'ethics-pro'
  | 'maturity-pro'
  | 'strategy-pro'
  | 'workspace-pro'
  | 'business-model-pro'
  | 'framework-engine'

interface ModuleSwitcherState {
  activeModule: ProModuleId
  previousModule: ProModuleId | null
  setActiveModule: (moduleId: ProModuleId) => void
}

export const useModuleSwitcher = create<ModuleSwitcherState>()(
  persist(
    (set, get) => ({
      activeModule: 'governance-pro',
      previousModule: null,

      setActiveModule: (moduleId: ProModuleId) => {
        const current = get().activeModule
        if (current === moduleId) return
        set({
          previousModule: current,
          activeModule: moduleId,
        })
      },
    }),
    {
      name: 'sgrc-adminclient-active-module',
      partialize: (state) => ({ activeModule: state.activeModule }),
    }
  )
)
